import script from "./login-account.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-account.vue?vue&type=script&setup=true&lang=ts"

import "./login-account.vue?vue&type=style&index=0&id=1bab1f71&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bab1f71"]])

export default __exports__